import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HTMLFileWrapper = styled(Box)`
  max-height: 77vh;
  overflow: auto;
  padding: 0 10px 10px 10px;
`;

export const StipReviewGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StipReviewGridVertical = styled(StipReviewGrid)`
  vertical-align: 'center';
`;